import { Autocomplete, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { supabase } from '../supabase';
import logo from '../assets/logo.png';
import loading_spinner from '../assets/loading_spinner.gif';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';

export default function AddReport(props) {
    const { session, reports, setReports, storageURL } = props;
    const [billingCodes, setBillingCodes] = useState([]);
    const [loadingAddReport, setLoadingAddReport] = useState(false);
    const [reportAdded, setReportAdded] = useState(false);
    const [clientBillingCodes, setClientBillingCodes] = useState([]);
    const [compareBillingCodes, setCompareBillingCodes] = useState([]);
    const [clientRate, setClientRate] = useState('');
    const [title, setTitle] = useState('');
    const [expectedNegotiation, setExpectedNegotiation] = useState('');

    useEffect(() => {
        const getBillingCodes = async () => {
            try {
                let { data, error, status } = await supabase
                    .from('BillingCode')
                    .select('billing_code')
        
                if (error && status !== 406) {
                    throw error
                }
                
                if (data) {
                    let tempBillingCodes = [];
                    data.forEach(code => {
                        tempBillingCodes.push({
                            "title": code.billing_code,
                            "value": code.billing_code
                        })
                    })
                    setBillingCodes(tempBillingCodes);
                }
        
            } catch (error) {
                console.log(error.message);
            }
        }

        getBillingCodes();
    }, []);

    // determine if mobile
    const [width, setWidth] = useState(window.innerWidth);
    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }
    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);
    const isMobile = width <= 768;

    const handleAddReport = async () => {
        setLoadingAddReport(true);

        // update local
        let newId = parseInt(reports[reports.length - 1].id) + 1;
        reports.push({
            "id": newId,
            "title": title,
            "logo": logo,
            "overallPosition": Math.round(Math.random(0, 100)),
            "numCodes": compareBillingCodes.length,
            "clientBillingCode": clientBillingCodes,
            "clientRate": clientRate,
            "compareBillingCodes": compareBillingCodes,
            "expectedNegotiation": expectedNegotiation,
            "URL": `${storageURL}/${session.user.id}/${title}.pdf`,
            "generated": false
        })
        setReports(reports);
        // save to supabase
        try {
            const updates = {
                id: session.user.id,
                reports: reports
            }

            let { error } = await supabase.from('Profile').upsert(updates).select()
            
            if (error) {
                throw error
            } else {
                setTimeout(function() { setLoadingAddReport(false); }, 500);
                setTimeout(function() { setReportAdded(true); }, 500);
            }

        } catch (error) {
            console.error(error.message)
        }

    };

    // const handleSelectedBillingCodesChange = (event, value) => {
    //     setSelectedBillingCodes(value);
    // };

    const date = new Date()
    const dateToday = (((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear());
    const dateInOneMonth = (((date.getMonth() > 8) ? (date.getMonth() + 2) : ('0' + (date.getMonth() + 2))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear());

    return (
        <div>
            {reportAdded ? (
                <div className='flex flex-col justify-center items-center' style={{height: '490px'}}>
                    <div className='bg-light-gray-2 rounded-full p-6'>
                        <FontAwesomeIcon icon={faCheckCircle} className="text-6xl text-green" />
                    </div>
                    <p className='text-3xl text-center font-extrabold tracking-tight mt-3'>Report created successfully</p>
                    <span className='text-xl text-center mt-3 italic'>Close this window to access your report on the dashboard.</span>
                </div>
            ) : (
                <div>
                    <p className='text-3xl font-extrabold tracking-tight mt-4'>Add Report</p>
                    <span className='text-xl text-light-gray-3 mt-1 italic'>Under development</span>
                    <p className='text-xl mt-3 mb-10'>
                        To begin your market reimbursement analysis report, please provide your practice information below.
                    </p>
                    <div className='flex justify-start items-center gap-4 mt-4'>
                        <p className='text-xl font-semibold mt-3'>1.</p>
                        <TextField
                            label="Report title"
                            variant='standard'
                            placeholder={`Competitive Analysis Report ${dateToday}`}
                            style={{width: isMobile ? '100%' : '500px'}}
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                        />
                    </div>
                    <div className='flex justify-start items-center gap-4 mt-4'>
                        <p className='text-xl font-semibold mt-3'>2.</p>
                        <Autocomplete
                            multiple
                            id="tags-standard"
                            style={{width: isMobile ? '100%' : '500px'}}
                            options={billingCodes}
                            getOptionLabel={(option) => option.title}
                            onChange={(event, value) => setClientBillingCodes(value)}
                            value={clientBillingCodes}
                            renderInput={(params) => (
                            <TextField
                                {...params}
                                variant='standard'
                                label="Select your billing codes"
                            />
                            )}
                        />
                    </div>
                    <div className='flex justify-start items-center gap-4 mt-4'>
                        <p className='text-xl font-semibold mt-3'>3.</p>
                        <TextField
                            label="Your rate for the billing code(s) above"
                            variant='standard'
                            placeholder={`$100.00`}
                            style={{width: isMobile ? '100%' : '500px'}}
                            value={clientRate}
                            onChange={(e) => setClientRate(e.target.value)}
                        />
                    </div>
                    <div className='flex justify-start items-center gap-4 mt-4'>
                        <p className='text-xl font-semibold mt-3'>4.</p>
                        <Autocomplete
                            multiple
                            id="tags-standard"
                            style={{width: isMobile ? '100%' : '500px'}}
                            options={billingCodes}
                            getOptionLabel={(option) => option.title}
                            onChange={(event, value) => setCompareBillingCodes(value)}
                            value={compareBillingCodes}
                            renderInput={(params) => (
                            <TextField
                                {...params}
                                variant='standard'
                                label="Billing codes you want to compare"
                            />
                            )}
                        />
                    </div>
                    <div className='flex justify-start items-center gap-4 mt-4'>
                        <p className='text-xl font-semibold mt-3'>5.</p>
                        <TextField
                            variant='standard'
                            label="Expected negotiation"
                            placeholder={dateInOneMonth}
                            style={{width: isMobile ? '100%' : '500px'}}
                            value={expectedNegotiation}
                            onChange={(e) => setExpectedNegotiation(e.target.value)}
                        />
                    </div>
                    <div className='flex justify-end text-center'>
                        <button
                            onClick={() => handleAddReport()}
                            className='text-white text-xl w-64 py-2 mt-5 bg-eggshell-green rounded-xl hover:bg-eggshell-dark-green'
                        >
                            {loadingAddReport ? (
                                <div className='flex justify-center items-center gap-2'>
                                    <img src={loading_spinner} className='h-8 text-center text-white' alt='Loading...' />
                                    <p className='text-xl'>Creating Report</p>
                                </div>
                            ) : (
                                <p className='py-0.5'>Create report</p>
                            )}
                        </button>
                    </div>
                </div>
            )}
        </div>
    )
}
